<div class="link-container">
  <a *ngIf="!fakeLink; else fake" [customRouterLink]="linkRef">
    <div class="link">
      <div *ngIf="iconMap[icon] as icon" [innerHTML]="icon" class="icon"></div>
      <div class="name {{ iconMap[icon] ? 'display' : ''}} {{ showTextOnMobile ? 'display-icon' : ''}}">
        <ng-container *ngIf="!alternativeText">
          {{ linkRef.linkName }}
        </ng-container>
        <ng-container *ngIf="alternativeText">
          {{ alternativeText }}
        </ng-container>
      </div>
    </div>
  </a>
  <ng-template #fake>
    <a (click)="emitClick()">
      <div class="link">
        <div *ngIf="iconMap[icon] as icon" [innerHTML]="icon" class="icon"></div>
        <div class="name {{ iconMap[icon] ? 'display' : ''}} {{ showTextOnMobile ? 'display-icon' : ''}}">
          <ng-container *ngIf="!alternativeText">
            {{ linkRef.linkName }}
          </ng-container>
          <ng-container *ngIf="alternativeText">
            {{ alternativeText }}
          </ng-container>
        </div>
      </div>
    </a>
  </ng-template>
</div>
